import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { AuthenticationContextProvider } from './contexts/Authentication';
import { ThemeContextProvider } from './contexts/Theme';
import { BrowserRouter as Router } from 'react-router-dom';
import settings from './settings';
import NotificationContextProvider from './contexts/Notification';

ReactDOM.render(
  <AuthenticationContextProvider>
    <ThemeContextProvider>
      <NotificationContextProvider>
        <Router basename={settings.baseUrl}>
          <App />
        </Router>
      </NotificationContextProvider>
    </ThemeContextProvider>
  </AuthenticationContextProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
